import angular from 'angular';
import {
  ssDialogService,
  utilityService
} from 'app/services';
import viewWebinarDialog from '../dialog.viewWebinarDialog';
import controller from './training-webinar.controller';
import directive from './training-webinar.directive';


export default angular.module('app.components.support.trainingWebinar', [
  ssDialogService,
  viewWebinarDialog,
  utilityService,
])
  .directive('trainingWebinar', directive)
  .controller('TrainingWebinarController', controller)
  .name;

console.log('app.components.support.trainingWebinar created');
